import { PageType, pageTypeMap, helpCenterPageTypePatterns } from '../pageTypeConstants';

export function getHelpCenterUrlFromPathname(pathname: string): PageType {
    const foundType = helpCenterPageTypePatterns.find(({ patterns }) =>
        patterns.some((pattern) => pathname.toLowerCase().includes(pattern.toLowerCase())),
    );
    return foundType ? foundType.type : pageTypeMap.HOME;
}
